import type { Components, Theme } from '@mui/material/styles';

const MuiSnackbarContent: Components<Theme>['MuiSnackbarContent'] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      fontFamily: 'Poppins',
      color: palette.background.paper,
      backgroundColor: palette.primary[1000],
      boxShadow: 'none'
    })
  }
};

export default MuiSnackbarContent;
